const id = {
  translation: {
    //home
    home: "Beranda",
    vehicles: "Kendaraan",
    sign_in: "Masuk",
    plan_you_trip: "Rencanakan perjalanan Anda sekarang",
    save_big: "Menjemput kesempatan dengan rental mobil terjangkau kami!",
    with_our_car: "dengan penyewaan mobil hemat kami!",
    save_big_desc:
      "Sewa mobil impian Anda. Harga tak terkalahkan, jarak tempuh tak terbatas, pilihan pengambilan yang fleksibel, dan masih banyak lagi.",
    book_ride: "Pesan Perjalanan",
    learn_more: "Pelajari Lebih Lanjut",
    book_a_car: "Pesan mobil",
    without_driver: "Tanpa Sopir",
    with_driver: "Dengan Sopir",
    select_booking_type: "Pilih Jenis Pemesanan",
    self_drive: "Mengemudi Sendiri",
    tour: "Tur / Sewa Harian",
    transfer_service: "Layanan Transfer",
    pickup_date: "Tanggal Penjemputan",
    dropoff_date: "Tanggal Pengantaran",
    pickup_location: "Lokasi Penjemputan",
    dropoff_location: "Lokasi Pengantaran",
    book_now: "Pesan Sekarang",
    the_price_exclude: "Harga belum termasuk biaya sopir, yang akan dikenakan biaya tambahan",
    select_tour_package: "Pilih Paket Tur",
    select_duration: "Pilih Durasi",
    destination_location: "Lokasi Tujuan",
    quick_and_easy: "Penyewaan mobil cepat & mudah",
    select_car: "Pilih Mobil",
    we_offer:
      "Kami menawarkan berbagai macam kendaraan untuk semua kebutuhan berkendara Anda. Kami memiliki mobil yang sempurna untuk memenuhi kebutuhan Anda",
    contact_operator: "Hubungi Operator",
    our_knowlage:
      "Operator yang berpengetahuan dan ramah kami selalu siap membantu dengan pertanyaan atau kekhawatiran apa pun",
    let_drive: "Mari Mengemudi",
    whether_you:
      "Baik Anda sedang mengeksplorasi jalan raya atau destinasi lain, kami menyediakan berbagai pilihan mobil untuk Anda.",
    vehicle_models: "Model Kendaraan",
    our_rental_fleet: "Armada Sewaan Kami",
    choose_from:
      "Pilih dari berbagai macam kendaraan luar biasa kami untuk disewa dalam petualangan atau perjalanan bisnis Anda berikutnya",
    reserve_now: "PESAN SEKARANG",
    save_big_bottom: "Hemat besar dengan penyewaan mobil murah kami!",
    top_airport: "Top Airport. Pemasok Lokal. ",
    support: "dukungan",
    why_choose_use: "Mengapa Memilih Kami",
    best_valued: "Penawaran terbaik yang pernah Anda temukan",
    discover_the_best:
      "Temukan penawaran terbaik yang pernah Anda temukan dengan penawaran tak terkalahkan kami. Kami berdedikasi untuk memberikan Anda nilai terbaik untuk uang Anda, sehingga Anda dapat menikmati layanan dan produk berkualitas tinggi tanpa merusak dompet Anda. Penawaran kami dirancang untuk memberi Anda pengalaman penyewaan yang ultimate, jadi jangan lewatkan kesempatan Anda untuk menghemat besar.",
    find_details: "Temukan detail",
    cross_city: "Perjalanan Antar Kota",
    take_your_driving:
      "Angkat pengalaman mengemudi Anda ke level berikutnya dengan kendaraan terbaik kami untuk petualangan lintas negara Anda.",
    all_inclusive: "Semua Termasuk Harga",
    get_everything:
      "Dapatkan semua yang Anda butuhkan dalam satu harga yang nyaman dan transparan dengan kebijakan harga semua termasuk kami.",
    no_hidden: "Tidak Ada Biaya Tersembunyi",
    enjoy_peace:
      "Nikmati kedamaian pikiran dengan kebijakan tanpa biaya tersembunyi kami. Kami percaya pada harga yang transparan dan jujur.",
    review_by_people: "Dinilai oleh Orang",
    client_testimonial: "Testimoni Pelanggan",
    client_testimonial_desc:
      "Temukan dampak positif yang telah kami berikan pada pelanggan kami dengan membaca testimoni mereka. Pelanggan kami telah mengalami layanan dan hasil kami, dan mereka dengan senang hati berbagi pengalaman positif mereka dengan Anda.",
    testi_aris:
      "Saya sangat menyukainya. Layanan ini sangat bagus seperti sopir yang datang tepat waktu dan tahu jalan. Sangat senang, layanan ini benar-benar keren. Mobilnya juga. Bau bersih dan semuanya berjalan lancar. Semoga Mas Yoyok (sopir) berhasil dan sehat, maka ya... Bagi pengusaha rental mobil, saya tidak ingin mengatakan apa-apa lagi. Karena tidak ada keluhan. Pokoknya, sukses.",
    testi_solomon:
      "Saya menyewa Avanza, tipe G, tahun 2016. Mobilnya tidak memiliki masalah, mesinnya lancar, bodi mobilnya terdaftar dengan rapi, dan yang paling penting saat Anda menyewa mobil, tim/grup WA sudah siap... untuk dokumen yang diminta... itu keren. yang utama adalah.",
    faq: "FAQ",
    frequently_asked: "Pertanyaan Sering Diajukan",
    frequently_asked_desc:
      "Pertanyaan Sering Diajukan tentang Proses Pemesanan Mobil Sewaan di Situs Web Kami: Jawaban atas Keprihatinan dan Pertanyaan Umum.",
    what_is_special: "1. Apa yang istimewa tentang membandingkan penawaran sewa mobil?",
    what_is_special_desc:
      "Membandingkan penawaran sewa mobil penting karena itu membantu menemukan penawaran terbaik yang sesuai dengan anggaran dan kebutuhan Anda, memastikan Anda mendapatkan nilai maksimal dari uang Anda. Dengan membandingkan berbagai pilihan, Anda dapat menemukan penawaran dengan harga lebih rendah, layanan tambahan, atau model mobil yang lebih baik. Anda dapat menemukan penawaran sewa mobil dengan melakukan penelitian online dan membandingkan harga dari berbagai perusahaan penyewaan yang berbeda.",
    how_do_2: "2. Bagaimana cara menemukan penawaran sewa mobil?",
    how_do_2_desc:
      "Anda dapat menemukan penawaran sewa mobil dengan melakukan penelitian online dan membandingkan harga dari berbagai perusahaan penyewaan yang berbeda. Situs web seperti Expedia, Kayak, dan Travelocity memungkinkan Anda membandingkan harga dan melihat pilihan penyewaan yang tersedia. Juga disarankan untuk mendaftar newsletter melalui email dan mengikuti perusahaan penyewaan mobil di media sosial untuk mendapatkan informasi tentang penawaran khusus atau promosi.",
    how_do_3: "3. Bagaimana cara menemukan harga sewa mobil yang rendah?",
    how_do_3_desc:
      "Pesan lebih awal: Memesan sewa mobil Anda lebih awal sering kali dapat menghasilkan harga yang lebih rendah. Bandingkan harga dari beberapa perusahaan: Gunakan situs web seperti Kayak, Expedia, atau Travelocity untuk membandingkan harga dari beberapa perusahaan penyewaan mobil. Cari kode diskon dan kupon: Cari kode diskon dan kupon yang dapat Anda gunakan untuk mengurangi harga sewa. Menyewa dari lokasi di luar bandara kadang-kadang dapat menghasilkan harga yang lebih rendah.",
    reservation_12: "Pemesanan harus dilakukan setidaknya 12 jam sebelumnya",
    reservation_24: "Pemesanan harus dilakukan setidaknya 24 jam sebelumnya",
    drop_after_pickup: "Tanggal pengembalian harus setelah tanggal pengambilan",
    //car card
    daily_rate_from: "Harga harian mulai dari",
    includes: "Termasuk",
    isurances_etc: "ASURANSI, LAYANAN PELANGGAN",
    more_info: "Informasi Lebih Lanjut",
    efficient: "Efisien",
    safe: "Aman",
    economical: "Hemat",
    //select vehicle
    book_car_by_getting: "Pesan mobil dengan menghubungi kami",
    select_vehicle: "Pilih Kendaraan",
    complete_reservation: "SELESAIKAN RESERVASI",
    upon_completing: "Setelah menyelesaikan permintaan reservasi ini, Anda akan menerima:",
    your_rent_voucher:
      "Voucher sewa Anda yang harus ditunjukkan saat tiba di meja penyewaan dan nomor dukungan pelanggan bebas pulsa.",
    location_n_date: "Lokasi & Tanggal",
    car: "Mobil",
    pickup_date_n_time: "Tanggal & Waktu Pengambilan",
    dropoff_date_n_time: "Tanggal & Waktu Pengembalian",
    prices: "Harga",
    additional_items: "Item Tambahan",
    umbrella: "Payung",
    baby_seat: "Kursi Bayi",
    insurance: "Asuransi",
    full_covered: "Asuransi ditanggung penuh",
    wedding: "Mobil Pengantin",
    flower_arrangement: "Susunan Bunga (Mobil Pernikahan)",
    additional_stop: "Biaya tambahan berhenti",
    flower_bouquet: "Buket Bunga",
    all_in_one_for: "Tol dan parkir",
    price_estimate: "Estimasi Harga",
    estimate_total: "Total Estimasi",
    the_price_does_not: "Harga tidak termasuk biaya tol, biaya parkir, tip.",
    the_price_includes: "Harga termasuk bensin dan biaya parkir satu arah",
    personal_info: "INFORMASI PRIBADI",
    identity_type: "Jenis Identitas",
    select_identity: "Pilih Identitas",
    identity_image: "Gambar Identitas",
    choose_file: "Pilih berkas",
    sim_or: "SIM / Surat Izin Mengemudi",
    name: "Nama",
    booker_name: "Nama pemesan",
    enter_booker_name: "Masukkan nama pemesan",
    enter_name: "Masukkan nama Anda",
    whatsapp_number: "Nomor Whatsapp",
    enter_whatsapp_number: "Masukkan nomor Whatsapp Anda",
    email: "Email",
    enter_email: "Masukkan alamat email Anda",
    address: "Alamat",
    enter_address: "Masukkan alamat Anda",
    emergency_contact_1: "Kontak Darurat 1",
    emergency_contact_2: "Kontak Darurat 2",
    enter_emergency: "Masukkan kontak darurat Anda",
    return_flight: "Pemesanan Penerbangan Kembali",
    hotel_accomodation: "Hotel/Akomodasi Selama Anda Menginap",
    notes: "Catatan",
    enter_notes: "Masukkan catatan Anda",
    we_will_ask: "Kami akan meminta data tambahan jika diperlukan.",
    rental_policy: "Kebijakan Sewa",
    in_town_usage: "Penggunaan di dalam kota",
    denpasar_jimbaran_etc: "Denpasar, Jimbaran, Legian, Nusa Dua, Uluwatu, Pusat Ubud, Seminyak.",
    out_of_town_usage: "Penggunaan di luar kota",
    add_outside_island: "Tambahkan penggunaan di luar pulau",
    outside_island_usage: "Penggunaan di Luar Pulau",
    for_self_drive: "Penggunaan di Luar Pulau untuk mengemudi sendiri",
    zone_1: "Zona 1",
    zone_2: "Zona 2",
    kerobokan_etc:
      "Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar (selain ubud center) (biaya tergantung pada jenis mobil)",
    karangasem_etc: "Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben (biaya tergantung pada jenis mobil)",
    this_rate_valid: "Tarif ini berlaku hanya untuk satu arah.",
    add_out_off_town: "Tambah penggunaan luar kota",
    select_date: "Pilih Tanggal",
    select_travel_date: "Pilih tanggal perjalanan di luar kota",
    select_travel_date_island: "Pilih tanggal perjalanan di luar pulau",
    total: "Total",
    close: "Tutup",
    add: "Tambah",
    loading: "Memuat...",
    // customer form
    additional_information: "Informasi Tambahan (Opsional)",
    guest_name: "Nama Tamu",
    driver_name: "Nama Pengemudi",
    passanger_total: "Total Penumpang",
    luggage_total: "Total Bagasi",
    flight_detail: "Detail Penerbangan",
    airline_name: "contoh: nama maskapai: Garuda, waktu kedatangan: 17.00",
    hotel_detail: "Detail Hotel/Akomodasi",
    hotel_name: "contoh: nama hotel: Hotel Indah",
    disability_needs: "Kebutuhan disabilitas",
    wheelchair: "contoh: kursi roda: 1",
    the_price_varies: "Harga bervariasi tergantung lokasi tujuan.",
    including_petrol: "Termasuk tol, dan parkir",
    change: "Ubah",
    setting_date_use: "Mengatur tanggal penggunaan",
    date: "Tanggal",
    //detail vehicle
    detail_vehicle: "Detail Kendaraan",
    price_type: "Jenis Harga",
    price: "Harga",
    area: "Area",
    yes: "Ya",
    trunk: "Bagasi",
    customer_service: "LAYANAN PELANGGAN",
    insurances: "ASURANSI",
    with_a_professional:
      "Dengan layanan purnajual yang profesional dan luas, Anda dapat bersantai karena dukungan yang baik dari tim kami. Anda juga dapat memanfaatkan berbagai penawaran menarik dan promosi khusus saat memesan mobil ini.",
    select_this_car: "Pilih mobil ini",
    //global
    save: "Simpan",
    big: "besar",
    days: "Hari",
    hour: "Jam",
    brand: "Merek",
    year: "Tahun",
    seat: "Kursi",
    ac: "AC",
    color: "Warna",
    transmission: "Transmisi",
    fuel: "Bahan Bakar",
    company: "Perusahaan",
    working_hour: "Jam Kerja",

    //privacy and police
    privacy_and_police: "Syarat dan Ketentuan",
    for_overtime:
      "Untuk Overtime akan dikenakan biaya Rp 50.000 / Jam (Overtime di atas 2 jam terhitung 1 hari pemakaian)",
    for_extension:
      "Untuk perpanjangan sewa unit lebih dari 2 kali, dimohon untuk verifikasi dan konfirmasi dilakukan di kantor kami Wirasana Rent A Car Denpasar Jl. Bypass Ngurah Rai No.162, Sanur Kaja, Denpasar Selatan",
    unit_vehicles:
      "Unit Kendaraan sewa tidak dapat di pindah tangankan / digunakan selain dari penyewa yang menandatangani kontrak sewa (Apabila mobil dijadikan sebagai barang bukti maka akan dikenakan biaya sewa perharinya)",
    reschedule_or:
      "Reschedule atau perubahan lokasi pengambilan/pengembalian unit tidak dapat dikonfirmasi apabila pemberitahuan kurang dari 1x24 jam sesuai jadwal bookingan, menghindari terjadinya kesalahan pengaturan operational",
    reschedule_date:
      "Reschedule tanggal atau jam Pengambilan unit / Pengembalian unit terdapat biaya sebesar Rp 75.000 (maksimal reschedule 2 kali)",
    for_lose_umbrella: "Untuk kehilangan payung selama masa sewa akan dikenakan biaya Rp 100.000/1 buah Payung",
    for_lose_baby_seat:
      "Untuk kehilangan Baby Car Seat selama masa sewa akan dikenakan biaya Rp 2.000.000/1 Baby Car Seat",
    usage_unit: "Pemakaian unit hanya untuk di daerah bali",
    lose_stnk: "Kehilangan STNK terdapat biaya sebesar Rp 1.500.000",
    lose_plat: "Kehilangan plat terdapat biaya sebesar Rp 250.000",
    for_damage_ban:
      "Untuk Kerusakan Ban dikarenakan salah penggunaan/Penggunaan selain di jalan Aspal akan dikenakan biaya Rp 700.000 / Ban",
    for_beret: "Jika ada Baret Baru maka akan kami kenakan biaya Rp 750.000 per kejadian",
    towing_fee: "Biaya towing car, biaya sewa mobil selama dalam perbaikan tidak termasuk dalam biaya own risk charge",
    lack_of_petrol: "Kekurangan bensin pada saat pengembali anter dapat biaya Rp 100.000 / kotak",
    fuel_in_the_middle:
      "Apabila mengalami kendala kehabisan Bahan Bakar Minyak di tengah perjalanan terdapat biaya penanganan Rp 250.000 untuk daerah dalam kota",
    smell:
      "Jika pada saat pengembalian mobil ada bau durian/muntah/rokok/jok kendaraan basah terdapat biaya Rp. 1.500.000",
    dirty_car: "Untuk mobil kembali sangat kotor terdapat biaya kebersihan Rp. 150.000",
    lost_the_key: "Untuk kehilangan kunci mobil akan dikenakan biaya Rp. 1.500.000",
    more_than_one_driver: "Apabila pengemudi lebih dari satu orang akan dikenakan Rp. 50.000/ID/hari",
    please_not_park: "Mohon untuk tidak parkir kendaraan di bawah pohon / lokasi yang membahayakan posisi kendaraan",
    charging_error: "Jika terjadi kesalahan pengisian Bahan Bakar terdapat biaya perbaikan sebesar Rp 2.500.000",
    not_info:
      "Apabila kami tidak menerima informasi terkait keperluan bantuan perbaikan kendaraan selama sewa, maka kami tidak menerima reimbursement dari bengkel manapun tanpa persetujuan/diskusi",
    trouble_car:
      "Jika ada kendala pada kendaraan, tim mekanik kami akan mengusahakan untuk menyusul dan membantu bapak/Ibu maksimal 4 Jam (Tergantung lokasi bapak/Ibu saat itu)",
    security_deposit:
      "Security Deposit Rp 500.000 akan di keep sebagai guarantee selama periode rental (Security deposit akan di refund melalui bank transfer maksimal 7 hari setelah pengembalian kendaraan dan setelah pengecekan E-Tilang)",
    basic_usage: "Penggunaan basic hanya untuk dalam kota sesuai peta Traveloka.",
    excess_usage:
      "Kelebihan pemakaian dari 12 jam atau di atas jam 12 malam akan dikenakan biaya tambahan sesuai lampiran/aturan Traveloka.",
    driver_contact: "Driver akan menghubungi Anda ketika mereka hampir tiba di lokasi penjemputan.",
    other_questions: "Jika Anda memiliki pertanyaan lain, jangan ragu untuk menghubungi kami.",
    pickup_point:
      "Titik jemput di depan Solaria, jika ingin request titik jemput lain bisa langsung info melalui group ini.",
    reschedule_info:
      "Perubahan jadwal atau lokasi penjemputan dan tujuan tidak dapat dikonfirmasi jika pemberitahuan kurang dari 24 jam sebelum jadwal bookingan, untuk menghindari kesalahan pengaturan operasional.",
    reschedule_fee: "Terdapat biaya reschedule sebesar Rp 75.000 (maksimal reschedule 2 kali).",
    reschedule_airline:
      "Untuk perubahan jadwal akibat perubahan maskapai, mohon lampirkan bukti perubahan jadwal, dan kami akan mengkonfirmasi tanpa biaya reschedule. Namun, jenis kendaraan yang akan menjemput akan tergantung pada ketersediaan kendaraan pada waktu reschedule.",
    airline_delay:
      "Dalam kasus keterlambatan maskapai, mohon sertakan bukti keterlambatan. Driver kami akan berupaya sebaik mungkin untuk menjemput sesuai dengan jadwal terbaru.",
    voucher_usage:
      "Voucher hanya berlaku untuk satu kali penjemputan tanpa pemberhentian atau perjalanan satu arah saja.",
    additional_stop_meals:
      "Pemberhentian tambahan untuk makanan, dll. akan dikenakan biaya tambahan sebesar Rp 100.000 per jam.",
    driver_wait_time:
      "Driver akan menunggu selama 30 menit. Jika lebih dari waktu yang ditentukan, akan dikenakan biaya tambahan sebesar Rp 100.000 per jam.",
    destination_change: "Perubahan lokasi tujuan akan dikenakan biaya tambahan sesuai lokasi.",
    no_eating_drinking: "Tidak diperbolehkan untuk makan dan minum yang menyebabkan tumpahan di dalam kendaraan.",
    boarding_landing: "Mohon konfirmasi jika sudah boarding dan landing di Bandara Ngurah Rai.",
    driver_details: "Detail driver akan kami berikan pada hari perjalanan.",
    mask_and_distance: "Mohon selalu memakai masker dan menjaga jarak di dalam kendaraan.",
    disinfected_vehicles: "Semua kendaraan Wirasana telah di-disinfektan sebelumnya.",
    SWAB_driver_charge: "Biaya tambahan untuk SWAB driver sebesar Rp 99.000 (jika diperlukan).",
    passenger: "Penumpang",
    use_the_current_location: "Gunakan lokasi saat ini",
    cancel: "Batal",
    confirm: "Konfirmasi",
    i_have_read_and_accept: "Saya telah membaca dan menyetujui Kebijakan Privasi",
    i_accept_the_privacy: "Saya menerima Kebijakan Privasi",
    open_filters: "Buka Filter",
    sort: "Urutkan",
    price_low_to_high: "Harga: Rendah ke Tinggi",
    price_high_to_low: "Harga: Tinggi ke Rendah",
    name_a_z: "Nama: A → Z",
    name_z_a: "Nama: Z → A",
    filters: "Filter",
    price_per_day: "Harga per Hari",
    total_passenger: "Total Penumpang",
    drivetrain: "Penggerak",
    clear_all: "Hapus Semua",
    apply_filters: "Terapkan Filter",
    search_car: "Cari Kendaraan",
    ready_to_continue_payment: "Siap untuk melanjutkan pembayaran?",
    please_review_payment: "Silakan periksa detail pembayaran Anda sebelum melanjutkan.",
    total_amount: "Total yang harus dibayar",
    proceed_to_payment: "Lanjutkan Pembayaran",
    about: "Tentang kami",
    about_company: "Tentang Perusahaan",
    about_headline: "Nyalakan mesinmu dan petualanganmu dimulai",
    about_description:
      "Meski tampak sederhana, kami berkomitmen memberikan pelayanan terbaik. Kami hadir untuk membuat setiap perjalanan Anda nyaman, aman, dan penuh pengalaman menyenangkan.",
    about_car_types: "Jenis Mobil",
    about_rental_outlets: "Cabang Penyewaan",
    about_repair_shop: "Bengkel Perawatan",
    about_book_car: "Sewa mobil dengan menghubungi kami",
    about_phone: "(0361) 286-066",
    language: "Bahasa",
    about_us: "Tentang Kami",
    contact_us: "Hubungi Kami",
    booking_type: "Jenis Pemesanan",
    the_royal_essence: "Esensi Kerajaan dari Perjalanan",
    relaxed_journey: "PERJALANAN PALING SANTAI",
    page_title: "Kontak",
    headline: "Butuh informasi tambahan?",
    description:
      "Seorang profesional multitalenta dengan keahlian di bidang riset, pengembangan, dan pembelajaran. Berpengalaman lebih dari 15 tahun.",
    phone_label: "Telepon",
    email_label: "Email",
    address_label: "Alamat",
    form_name: "Nama Lengkap",
    form_message: "Ceritakan kepada kami",
    form_placeholder_name: "Misal: 'Budi Santoso'",
    form_placeholder_message: "Tulis di sini...",
    form_button: "Kirim via WhatsApp",
    required_alert: "Mohon isi semua kolom yang wajib!",
    address_value: "Denpasar, Bali",
    why_choose_wirasana: "Mengapa Memilih Wirasana",
    trusted_partner: "Mitra Terpercaya Anda untuk Sewa Mobil di Bali",
    experience_excellence:
      "Rasakan layanan terbaik dengan armada premium, pelayanan istimewa, dan harga tak tertandingi.",
    happy_customers: "Pelanggan Puas",
    vehicles_available: "Kendaraan Tersedia",
    years_experience: "Tahun Pengalaman",
    satisfaction_rate: "Tingkat Kepuasan",
    what_makes_us_different: "Apa yang Membuat Kami Berbeda",
    discover_advantages: "Temukan keunggulan yang membedakan kami dari kompetitor",
    comprehensive_insurance: "Asuransi Lengkap",
    comprehensive_insurance_desc:
      "Asuransi penuh disertakan di setiap penyewaan. Berkendara dengan tenang karena Anda terlindungi.",
    premium_fleet: "Armada Premium",
    premium_fleet_desc: "Kendaraan modern yang terawat dengan baik dan rutin diservis untuk kenyamanan Anda.",
    support_247: "Dukungan 24/7",
    support_247_desc: "Layanan pelanggan siap membantu Anda kapan pun dibutuhkan.",
    best_price: "Jaminan Harga Terbaik",
    best_price_desc: "Harga bersaing dengan transparansi penuh. Tanpa biaya tersembunyi, tanpa kejutan.",
    flexible_rental: "Sewa Fleksibel",
    flexible_rental_desc: "Pilih durasi sewa mulai dari per jam hingga bulanan. Kami menyesuaikan dengan jadwal Anda.",
    free_delivery: "Pengantaran Gratis",
    free_delivery_desc: "Layanan antar jemput kendaraan gratis di lokasi pilihan Anda di Bali.",
    more_reasons: "Alasan Lain untuk Mempercayai Kami",
    trusted_by_thousands: "Dipercaya Ribuan Orang",
    trusted_by_thousands_desc:
      "Lebih dari 10.000 pelanggan puas telah memilih kami untuk kebutuhan transportasi mereka di Bali.",
    licensed_insured: "Berlisensi & Diasuransikan",
    licensed_insured_desc: "Armada kami memiliki lisensi dan asuransi penuh untuk keselamatan dan kenyamanan Anda.",
    easy_booking: "Proses Pemesanan Mudah",
    easy_booking_desc: "Pesan online dalam hitungan menit tanpa proses rumit.",
    flexible_payment: "Pilihan Pembayaran Fleksibel",
    flexible_payment_desc:
      "Menerima berbagai metode pembayaran termasuk kartu kredit, transfer bank, dan dompet digital.",
    cta_title: "Siap Memulai Perjalanan Anda?",
    cta_desc: "Pesan kendaraan ideal Anda hari ini dan rasakan perbedaan Wirasana.",
    call_us_now: "Hubungi Kami Sekarang",
    back: "Kembali",
    weather_protection: "Perlindungan cuaca untuk aktivitas luar ruangan",
    safety_seat_children: "Kursi pengaman untuk anak-anak (5–4 tahun)",
    beautiful_flower_arrangements: "Rangkaian bunga indah untuk acara spesial",
    extra_stops: "Pemberhentian tambahan selama perjalanan",
    all_in_one_package: "Paket lengkap untuk kenyamanan",
    fresh_flower_bouquet: "Rangkaian buket bunga segar",
    set_quantity_each_date: "Atur jumlah untuk setiap tanggal",
    total_items: "Total item",
    items: "Item",
    select_all: "Pilih Semua",
    select_dates_apply_item: "Pilih tanggal yang ingin diterapkan untuk item ini",
    item_will_be_applied: "Item akan diterapkan",
    out_of: "dari",
    total_day: "total hari",
    type_or_choose_location: "Ketik lokasi atau pilih dari daftar...",
    select_from_map: "Pilih lokasi dari peta",
    popular_locations: "Lokasi Populer",
    manual_input_hint: "Atau ketik lokasi secara manual di kolom pencarian",
    common: {
      back: "Kembali",
      back_to_search: "Kembali ke Pencarian",
      name: "Nama",
      email: "E-mail",
      phone: "Telepon",
      total: "Total",
      hours: "Jam",
      processing: "Pengolahan...",
      searching: "Mencari...",
      error_occurred: "Terjadi kesalahan. ",
      information: "Informasi",
    },
    booking: {
      detail: "Detail Pemesanan",
      booking_number: "Pemesanan #{{number}}",
      not_found: "Data Tidak Ditemukan",
      search_again: "Silakan cari kembali pemesanan Anda",
      type: "Jenis Pemesanan",
      pickup_date: "Tanggal Pengambilan",
      dropoff_date: "Tanggal Pengantaran",
      price_breakdown: "Rincian Harga",
      price_date: "Harga ({{date}})",
      fees: "Biaya Transaksi & Pajak",
      delivery_fee: "Biaya Pengiriman",
      pickup_fee: "Biaya Penjemputan",
      canceled: "Pesanan Dibatalkan",
      contact_customer_service: "Pesanan ini telah dibatalkan. ",
      check_history: "Periksa Riwayat Pemesanan",
      enter_details: "Masukkan email dan kode pemesanan Anda untuk melihat detail pesanan Anda",
      booking_code: "Kode Pemesanan",
      code_example: "Contoh: S-0018, T-0025 (gunakan S-0018 untuk demo)",
      check_booking: "PERIKSA PEMESANAN",
      info_code_sent: "Kode pemesanan dikirim ke email Anda setelah pemesanan",
      info_continue_payment: "Anda dapat melanjutkan pembayaran untuk pesanan yang belum dibayar",
      info_contact_support: "Hubungi layanan pelanggan jika Anda mengalami masalah",
    },
    status: {
      booked: "Dipesan",
      prepared: "Siap",
      operated: "Dioperasikan",
      canceled: "Dibatalkan",
      success: "Kesuksesan",
    },
    payment: {
      not_paid: "Tidak Dibayar",
      paid: "Dibayar",
      partial: "Pembayaran Sebagian",
      continue: "LANJUTKAN PEMBAYARAN",
      invoice_not_found: "Faktur tidak ditemukan",
      link_failed: "Gagal membuat tautan pembayaran. ",
      received: "Pembayaran Diterima",
      total_paid: "Jumlah yang dibayarkan: {{amount}}",
    },
    validation: {
      fill_all_fields: "Silakan isi email dan kode pemesanan",
    },
    manage_booking: "Kelola Pemesanan",
    booking_confirmation: "Konfirmasi Pemesanan",
    next: "Berikutnya",
    booking_details: "Detail Pemesanan",
    review_n_confirm: "Tinjau & Konfirmasi",
    booking_success: "Pemesanan Berhasil!",
    booking_success_message: "Pemesanan Anda telah berhasil dikirimkan. ",
    open_payment_link: "Buka Tautan Pembayaran",
    required_documents: "Dokumen yang Diperlukan",
    payment_information: "Informasi Pembayaran",
    review_payment_details: "Harap tinjau detail pembayaran Anda dan lanjutkan ke pembayaran",
    booking_summary: "Ringkasan Pemesanan",
    invoice_number: "Nomor Faktur",
    customer_name: "Nama Pelanggan",
    payment_instructions: "Petunjuk Pembayaran",
    payment_instruction_1: "Klik tombol di bawah untuk membuat faktur pembayaran",
    payment_instruction_2: "Anda akan diarahkan ke halaman pembayaran Xendit",
    payment_instruction_3: "Selesaikan pembayaran Anda menggunakan metode pembayaran yang tersedia",
    payment_instruction_4: "Anda akan menerima email konfirmasi setelah pembayaran berhasil",
    payment_link_created: "Tautan pembayaran telah dibuat!",
    click_below_to_proceed: "Klik tombol di bawah untuk melanjutkan ke pembayaran",
    creating_invoice: "Membuat Faktur...",
    create_payment_invoice: "Buat Faktur Pembayaran",
    done: "Saya sudah menyelesaikan pembayarannya",
    order_summary: "Ringkasan Pesanan",
    please_review_order: "Silakan periksa detail pesanan Anda sebelum melanjutkan ke pembayaran",
    customer_information: "Informasi Pelanggan",
    phone: "Telepon",
    vehicle: "Kendaraan",
    rental_period: "Periode Sewa",
    locations: "Lokasi",
    price_breakdown: "Rincian Harga",
    base_price: "Harga Dasar",
    delivery_fee: "Biaya Antar",
    pickup_fee: "Biaya Jemput",
    tour_package: "Harga paket tour mulai dari",
    airport_transfer_from: "Harga layanan transfer mulai dari",
    tourPackage: "Paket Tour",
    duration: "Durasi",
    basic_title: "Basic Protection",
    basic_subtitle: "Perlindungan dasar yang termasuk dalam penyewaan Anda",
    km_unlimited: "Kilometer tidak terbatas",
    own_risk: "Dengan biaya own risk Rp 750.000/titik kecelakaan",
    damage_cover: "Kerusakan akibat tabrakan, goresan, dan benturan",
    glass_tire: "Perlindungan Ban dan Kaca",
    interior_protect: "Perlindungan Interior",
    not_included_towing:
      "Biaya tidak termasuk jika diperlukan derek mobil dan biaya sewa lebih dari 7 hari selama perbaikan di bengkel",
    got_it: "Mengerti",
    basic_protection: "Perlindungan Dasar",
    see_more_details: "Lihat lebih detail",
    insurance_protection: "Perlindungan Asuransi",
    click_to_see_details: "Klik untuk melihat detail perlindungan",
    choose_insurance: "Pilih Paket Perlindungan",
    select_best_protection: "Pilih paket yang sesuai dengan kebutuhan Anda",
    selected: "Dipilih",
    online_discount: "Diskon Online",
    day: "hari",
    free: "Gratis",
    additional_cost_per_day: "Biaya tambahan / hari",
    select_package: "Pilih Paket",
    most_popular_choice: "Pilihan yang paling populer",
    insurance_info_title: "Informasi Penting",
    insurance_info_description:
      "Kami selalu bertujuan untuk memberikan perlindungan terbaik kepada pelanggan kami. Kami menyediakan beberapa pilihan asuransi yang dapat Anda pilih sesuai kebutuhan Anda. Asuransi ini akan menjadi acuan dan perlindungan jika terjadi hal buruk pada Anda.",
    confirm_selection: "Konfirmasi Pilihan",
    insurance_no_extra_protection: "No Extra Protection",
    insurance_no_extra_protection_subtitle: "10% diskon dari Harga Publish",
    insurance_no_extra_protection_desc1_id: "10% diskon dari Harga Publish",
    insurance_no_extra_protection_desc2_id: "Kilometer tidak terbatas",
    insurance_no_extra_protection_desc3_id: "Semua biaya perbaikan menjadi tanggung jawab penyewa",
    insurance_no_extra_protection_desc4_id: "Kerusakan akibat tabrakan, goresan, dan benturan",
    insurance_no_extra_protection_desc5_id: "Perlindungan Ban dan Kaca",
    insurance_no_extra_protection_desc6_id: "Perlindungan Interior",

    insurance_basic_protection: "Basic Protection",
    insurance_basic_protection_subtitle: "Harga Publish",
    insurance_basic_protection_desc1_id: "Kilometer tidak terbatas",
    insurance_basic_protection_desc2_id: "Dengan biaya own risk Rp 750.000/titik kecelakaan",
    insurance_basic_protection_desc3_id: "Kerusakan akibat tabrakan, goresan, dan benturan",
    insurance_basic_protection_desc4_id: "Perlindungan Ban dan Kaca",
    insurance_basic_protection_desc5_id: "Perlindungan Interior",
    insurance_basic_protection_desc6_id:
      "Biaya tidak termasuk jika diperlukan derek mobil dan biaya sewa lebih dari 7 hari selama perbaikan di bengkel",
    gps: "GPS",
    gps_desc: "Sistem navigasi di dalam mobil.",
    phone_holder: "Phone Holder",
    phone_holder_desc: "Dudukan ponsel untuk berkendara aman.",
    family_card: "Kartu Keluarga",
    business_id: "Identitas Usaha",
    social_media: "Media Sosial",
    customer_info: "Informasi Pelanggan",
    enter_social_media: "Masukkan media sosial",
    insurance_subtitle: "Lindungi perjalanan Anda dengan cakupan komprehensif dan ketenangan pikiran",
    included: "Termasuk",
    not_included: "Tidak Termasuk",
    toll_and_parking: "Tol dan Parkir",
    toll_and_parking_desc: "Biaya tol dan parkir",
    your_trusted_mobility: "Mitra Mobilitas Tepercaya Anda di Bali",
    wirasana_is_professional:
      "Wirasana Rent A Car adalah layanan sewa mobil profesional yang berbasis di Bali, berdedikasi untuk menyediakan solusi transportasi yang andal, nyaman, dan fleksibel bagi wisatawan dan bisnis. Dengan pengalaman bertahun-tahun di industri transportasi, kami memahami bahwa mobilitas adalah bagian penting dari setiap perjalanan — baik untuk liburan, bisnis, atau acara khusus.",
    our_mission_is_to_make:
      "Misi kami adalah membuat transportasi di Bali menjadi sederhana, aman, dan terjangkau. Kami menawarkan berbagai kendaraan terawat dengan baik untuk memenuhi kebutuhan yang berbeda, dari mobil kompak untuk perjalanan pribadi hingga kendaraan premium untuk bisnis dan acara khusus.",
    lets_get_you: "Ayo Segera Mulai Perjalanan Anda",
    have_questions_about:
      "Ada pertanyaan tentang kendaraan, harga, atau ketersediaan kami? Tim kami siap membantu Anda. Baik Anda merencanakan liburan di Bali, perjalanan bisnis, atau acara khusus, kami di sini untuk membuat pengalaman transportasi Anda lancar dan bebas repot.",
    search_vehicle: "Cari Kendaraan",
    vehicle_type: "Jenis Kendaraan",
    motorcycle: "Motor",
    all: "Semua",
    your_trustedcar_rental_in_bali: "Rental Mobil Tepercaya Anda di Bali",
    simple_booking: "Pemesanan Mudah. Mobil Terpercaya. Layanan Istimewa.",
    we_provide_flexible:
      "Kami menyediakan solusi sewa fleksibel termasuk lepas kunci, layanan sopir, dan transfer bandara yang semuanya dirancang untuk membuat perjalanan Anda di Bali menjadi mudah.",
  },
};

export default id;
